import {
  configAnalytics,
  configNewRelic,
} from "@origin-digital/reporting-client";
import { configFetch, configFetchCache } from "@origin-digital/daxi";
import { config, appName } from "./config";

declare const __DEV__: boolean;

// Ensure webpack loads async chunks from the correct base URL.
// The app is hosted under a route prefix (e.g. /my/payment-settings) in non-dev envs.
// If webpack's publicPath is left as "/", chunk requests will go to the CDN root and 404.
declare let __webpack_public_path__: string;

declare global {
  interface Window {
    oetal: any;
    __BASEPATH__: string;
  }
}

// In dev we rely on the dev server; in deployed envs derive from the TAL-provided route.
// Normalize to always end with a trailing slash.
if (!__DEV__) {
  const base = window.__BASEPATH__ || "";
  if (base.length > 0) {
    __webpack_public_path__ = base.endsWith("/") ? base : `${base}/`;
  }
}

const envAppName = `${appName}-${config.env}`;

configAnalytics({ appName, debugToConsole: config.analyticsDebugToConsole });

configNewRelic({
  logLevel: config.logLevelNewRelic,
  consoleLogLevel: config.logLevelConsole,
  sendOnErrors: true,
  appName: envAppName,
  endpoint: "https://log-api.newrelic.com/log/v1",
  apiKey: config.newRelicCollectorKey,
  sourceEnv: config.env as EnvironmentNames,
});

/* eslint-disable-next-line no-undef */
configFetch({ disableAuthCheck: __DEV__ });
configFetchCache({ disableCache: __DEV__ });

if (__DEV__) {
  require("./mocks/eventDispatcherMocks");
}
